export enum Position{
    LEFT,
    RIGHT
}

export default interface ProjectStackProps {
    // endIcon: React.ReactElement;
    path: string;
    position: Position;
    alt: string;
    isStart: boolean;
    isMobile?: boolean;
}